var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMillustrationsPagerduty = function SvgMillustrationsPagerduty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.04,
    d: "M0 2a2 2 0 0 1 2-2h52a2 2 0 0 1 2 2v36a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 23,
    x: 8.5,
    y: 8.5,
    fill: "#fff",
    stroke: "#CCCCD9",
    rx: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8A8A99",
    fillRule: "evenodd",
    d: "M27.14 14c1.543 0 2.202.082 3.141.59 1.022.548 1.653 1.639 1.653 2.996 0 1.262-.515 2.352-1.502 3.004-.905.603-1.934.685-3.305.685h-3.463V14zm-1.714 5.753h2.106c1.474 0 2.598-.59 2.598-2.146 0-1.447-.905-2.078-2.715-2.064l-1.989.014zm-1.762 3.052h1.762V26h-1.762z",
    clipRule: "evenodd"
  })));
};
export default SvgMillustrationsPagerduty;